import React from 'react';
import { Table, Popover, Button, Badge, Icon } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import axios from 'axios';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as actions from '../store/actions/auth';
import { Card, Col, Row } from 'antd';
import {
  G2,
  Chart,
  Geom,
  Axis,
  Tooltip,
  Coord,
  Label,
  Legend,
  View,
  Guide,
  Shape,
  Facet,
  Util
} from "bizcharts";
import DataSet from "@antv/data-set";


const API_HOST_URL = process.env.REACT_APP_API_URL

class Dashboard extends React.Component {

    state = {
      leaveBalances: [],
      employeesOnLeave: [],
      leaveRequests: [],
      leaveRequestsByDepartment: []
    }

    componentDidMount(){
      this.leaveBalances();
      this.myLeaveRequests();
      this.leaveRequestsByDepartment();
    }

    leaveBalances = () => {
      axios.get(`${API_HOST_URL}/api/leave/leavebalance/?expand=employee&expand=leaveType&employee=${this.props.loggedInEmployee.id}`)
        .then(res => {
          this.setState({
            leaveBalances: res.data
          })
        })
    }

    myLeaveRequests = () => {
      axios.get(`${API_HOST_URL}/api/leave/leaverequest/?expand=employee&expand=leaveType&employee=${this.props.loggedInEmployee.id}`)
        .then(res => {
          this.setState({
            leaveRequests: res.data
          })
        })
    }

    leaveRequestsByDepartment = () => {
      axios.get(`${API_HOST_URL}/api/systemsetup/department/total_leave_requests_by_department/`)
        .then(res => {
          this.setState({
            leaveRequestsByDepartment: res.data
          })
        })
    }

    changeHeaderTitle(title){
      this.props.changeHeaderTitle(title);
    }

    leaveDuration(hours){
      let days = 0;
      let eightHourDay_hours = 0;
      let extraHours = 0;
      if(hours >= 8 ){
        console.log("Postive hours "+ hours);
        eightHourDay_hours = (8 * hours)/24;
        days = Math.trunc(eightHourDay_hours/8);
        extraHours = Math.trunc(eightHourDay_hours % 8)
        return days + (days>1?' days':' day') + ', ' + extraHours  + (extraHours>1?' hours':' hour')
      } else {
        extraHours = hours;
        return extraHours + (extraHours>1?' hours':' hour')
      } 
    }

    columns = [
      {
        title: 'Leave Type',
        dataIndex: 'leaveType.leaveType',
        key: 'leaveType'
      },
      {
        title: 'Leave Balance',
        dataIndex: 'leaveBalance',
        key: 'leaveBalance'
      }
    ];

    columns_my_leave_requests = [
      {
        title: 'Leave Type',
        dataIndex: 'leaveType.leaveType',
        key: 'leaveType'
      },
      {
        title: 'From',
        dataIndex: 'fromDate',
        key: 'fromDate',
        render: (record) => (
          moment(record).format('DD/MM/YYYY HH:mm')
        )
      },
      {
        title: 'To',
        dataIndex: 'toDate',
        key: 'toDate',
        render: (record) => (
          moment(record).format('DD/MM/YYYY HH:mm')
        )
      },
      {
        title: 'Status',
        // dataIndex: 'action',
        key: 'status',
        render: (record) => (
              <span style={{color: record.status === 'Approved' && record.status!=='Pending'? 'green': (record.status === 'Denied'?'red':'black') }}>
                {record.status}
              </span>
        )
      },
    ];
  
    
    render() {

      const { DataView } = DataSet;
      const { Html } = Guide;
      let data = [];
    //   [
    //   {
    //     item: "IT",
    //     count: 40
    //   },
    //   {
    //     item: "HR",
    //     count: 21
    //   },
    //   {
    //     item: "Finance",
    //     count: 17
    //   },
    //   {
    //     item: "Sales",
    //     count: 13
    //   },
    //   {
    //     item: "Admin",
    //     count: 9
    //   }
    // ];

    this.state.leaveRequestsByDepartment.forEach(department => {
      data.push({item: department.department, count: department.requests})
    })
    
    const dv = new DataView();
    dv.source(data).transform({
      type: "percent",
      field: "count",
      dimension: "item",
      as: "percent"
    });
    const cols = {
      percent: {
        formatter: val => {
          val = val * 100 + "%";
          return val;
        }
      }
    };

    
    const data2 = [
      {
        item: "Male",
        count: 60
      },
      {
        item: "Female",
        count: 40
      }
    ];
    const dv2 = new DataView();
    dv2.source(data2).transform({
      type: "percent",
      field: "count",
      dimension: "item",
      as: "percent"
    });
    const cols2 = {
      percent: {
        formatter: val => {
          val = val * 100 + "%";
          return val;
        }
      }
    };

      return (
        <div style={{ background: '#ECECEC', padding: '10px' }}>
        {
              this.props.userContentTypes.indexOf('systemsetup') > -1 ?
        <Row gutter={16}>
          <Col span={12}>
            <Card title="Leave By Department" bordered={false} >
              <div>
                <Chart
                  height={window.innerHeight-200}
                  data={dv}
                  scale={cols}
                  padding={[80, 100, 100, 80]}
                  forceFit
                >
                  <Coord type={"theta"} radius={0.75} innerRadius={0.6} />
                  <Axis name="percent" />
                  <Legend
                    position="right"
                    offsetY={-window.innerHeight/2 +120 }
                    offsetX={-100}
                  />
                  <Tooltip
                    showTitle={false}
                    itemTpl="<li><span style=&quot;background-color:{color};&quot; class=&quot;g2-tooltip-marker&quot;></span>{name}: {value}</li>"
                  />
                  <Guide>
                    <Html
                      position={["50%", "50%"]}
                      html="<div style=&quot;color:#8c8c8c;font-size:0.8em;text-align: center;width: 6em;&quot;>Employees on Leave<br><span style=&quot;color:#262626;font-size:1.5em&quot;></span></div>"
                      alignX="middle"
                      alignY="middle"
                    />
                  </Guide>
                  <Geom
                    type="intervalStack"
                    position="percent"
                    color="item"
                    tooltip={[
                      "item*percent",
                      (item, percent) => {
                        percent = percent * 100 + "%";
                        return {
                          name: item,
                          value: percent
                        };
                      }
                    ]}
                    style={{
                      lineWidth: 1,
                      stroke: "#fff"
                    }}
                  >
                    <Label
                      content="percent"
                      formatter={(val, item) => {
                        return item.point.item + ": " + val;
                      }}
                    />
                  </Geom>
                </Chart>
              </div>
            </Card>
          </Col>
          <Col span={12}>
            <Card title="Leave by Gender" bordered={false}>
              <div>
                <Chart
                  height={window.innerHeight-200}
                  data={dv2}
                  scale={cols2}
                  padding={[80, 100, 100, 80]}
                  forceFit
                >
                  <Coord type="theta" radius={0.75} />
                  <Axis name="percent" />
                  <Legend
                    position="right"
                    offsetY={-window.innerHeight / 2 + 120}
                    offsetX={-100}
                  />
                  <Tooltip
                    showTitle={false}
                    itemTpl="<li><span style=&quot;background-color:{color};&quot; class=&quot;g2-tooltip-marker&quot;></span>{name}: {value}</li>"
                  />
                  <Geom
                    type="intervalStack"
                    position="percent"
                    color="item"
                    tooltip={[
                      "item*percent",
                      (item, percent) => {
                        percent = percent * 100 + "%";
                        return {
                          name: item,
                          value: percent
                        };
                      }
                    ]}
                    style={{
                      lineWidth: 1,
                      stroke: "#fff"
                    }}
                  >
                    <Label
                      content="percent"
                      formatter={(val, item) => {
                        return item.point.item + ": " + val;
                      }}
                    />
                  </Geom>
                </Chart>
              </div>
            </Card>
          </Col>
        </Row>
        : ''}

        <div style={{ background: '#ECECEC', padding: '10px' }}>
          <Row gutter={24}>
            <Col span={12}>
              <Card title="My leave balances" bordered={false}
                     extra={<Link to="/myleavebalance" onClick={()=>this.changeHeaderTitle('My Leave Balances')}>More</Link>}
              >
              {
                this.props.userPermissions.indexOf('access_my_leavebalance') > -1 ? 
                <Table columns={this.columns} dataSource={this.state.leaveBalances} rowKey="id"/>
                : 'You do not have rights to access your leave balances. Please contact your administrator'
              }
              </Card>
            </Col>
            <Col span={12}>
              <Card title="My Leave applications" bordered={false}
                extra={<Link to="/myleaverequest" onClick={()=>this.changeHeaderTitle('My Leave Requests')}>More</Link>}
              >
              {
                this.props.userPermissions.indexOf('access_my_leave') > -1 ? 
                <Table columns={this.columns_my_leave_requests} dataSource={this.state.leaveRequests} rowKey="id"/>
                : 'You do not have rights to access your leave requests. Please contact your administrator'
              }
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      );
    }
  }
  
  const mapStateToProps = state => {
    return {
      isAuthenticated: state.token !== null,
      loggedInEmployee: state.loggedInEmployee,
      userPermissions: state.userPermissions,
      userContentTypes: state.userContentTypes
    }
  }

  const mapDispatchToProps = dispatch => {
    return {
      changeHeaderTitle: (title) => dispatch(actions.changeHeaderTitle(title))
    }
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
// export default Dashboard;